
import { useState } from "react";
import { toast } from "react-toastify";
import { ApiTypes } from "../constants/Constants";
import { POSTAPI , GETAPI , POSTAPIFORMDATA } from "../config/Api";

const useMakeRequest = () => {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(false);
    const [data, setData] = useState<any>(null);
    const [error, setError] = useState<any>(null);

    const makeRequest = async ({ payload = {}, url, type = ApiTypes?.POST, toastStatus = false }: {
        payload?: any,
        url: string,
        type?: string,
        toastStatus?: boolean,
    }) => {
        try {
            setLoading(true);
            setStatus(false);
            setError(null);
            setData(null)

            const apiBaseUrl = process.env.NEXT_PUBLIC_API_URL;

            let data = null;
            if (type === ApiTypes?.GET) {
                data = await GETAPI(url, payload, toastStatus);
            } else if (type === ApiTypes?.POST) {
                data = await POSTAPI(url, payload, toastStatus);
            }
            else if (type === ApiTypes?.POSTAPIFORMDATA) {
                data = await POSTAPIFORMDATA(url, payload, toastStatus);
            }
            if (data && data?.status == true) {
                setStatus(true);
                setLoading(false);
                setError(null);
                setData(data)
            } else {
                setStatus(false);
                setLoading(false);
                setError(data);
                setData(null)
            }

        } catch (error: any) {
            toast.error(error?.response?.data?.message)
            setError(error);
            setStatus(false);
            setLoading(false);
            setData(null);
            throw error;
        }
    };

    const reset = () => {
        setLoading(false);
        setStatus(false);
        setError(null);
        setData(null)
    }
    return { loading, data, error, status, reset, makeRequest };
};

export default useMakeRequest;